module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-08.6250e195.png";